import { createApi } from '@reduxjs/toolkit/query/react';

import { TStatistic } from '@/types/statistic';

import { baseQueryWithReauth } from './utils';

export const statisticApi = createApi({
  reducerPath: 'statisticApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getStatistic: build.query({
      query: (params: {
        customerId?: string;
        models?: string[];
        providers?: string[];
        startAt?: string;
        endAt?: string;
        }) => ({
        url: 'statistic/get-statistics',
        method: 'POST',
        body: {
          ...params,
        },
      }),
      transformResponse: (response: TStatistic[]) => response,
    }),
    getStatisticFilters: build.query({
      query: (params: {
        customerId?: string;
        }) => ({
        url: 'statistic/get-filters-data',
        method: 'POST',
        body: params,
      }),
    }),
  })
});

export const {
  useGetStatisticQuery,
  useGetStatisticFiltersQuery,
} = statisticApi;